import { useState, type KeyboardEvent } from 'react';
import { Link } from 'react-router-dom';
import { useDeconnexion, useFile } from '../horsligne/contexte-file';
import { saisies } from '../horsligne/textes';

/**
 * Déconnexion volontaire alors que des saisies du compte attendent sur le
 * téléphone (docs/UI.md § Écran 3, mode hors ligne) : se déconnecter les
 * efface, rien ne part sans confirmation. « Rester connecté » est le choix par
 * défaut.
 */
export function ConfirmerDeconnexion() {
  const { dialogue, confirmer, envoyerPuisDeconnecter, annuler } = useDeconnexion();
  const { instantane } = useFile();
  const [occupe, setOccupe] = useState<'envoi' | 'deconnexion' | null>(null);
  if (!dialogue) return null;
  const { nombre, refusees, apresEnvoiPartiel } = dialogue;
  const plusieurs = nombre > 1;
  const enLigne = instantane.enLigne;

  async function executer(genre: 'envoi' | 'deconnexion', action: () => Promise<void>): Promise<void> {
    setOccupe(genre);
    try {
      await action();
    } finally {
      setOccupe(null);
    }
  }

  function surTouche(evenement: KeyboardEvent): void {
    if (evenement.key === 'Escape' && occupe === null) annuler();
  }

  return (
    <div className="dialogue-fond">
      <dialog
        open
        className="dialogue"
        aria-modal="true"
        aria-labelledby="titre-deconnexion"
        onKeyDown={surTouche}
      >
        <h2 id="titre-deconnexion">
          {saisies(nombre)} pas encore {plusieurs ? 'envoyées' : 'envoyée'}
        </h2>
        {apresEnvoiPartiel && (
          <p className="signal">
            {saisies(nombre)} {plusieurs ? 'n’ont' : 'n’a'} pas pu partir (
            {refusees > 0 ? (plusieurs ? 'refusées' : 'refusée') : 'réseau indisponible'}).{' '}
            <Link to="/envois" onClick={annuler}>
              Voir
            </Link>
          </p>
        )}
        <p>
          {plusieurs
            ? 'Elles sont gardées sur ce téléphone jusqu’à leur envoi. Vous déconnecter maintenant les efface définitivement.'
            : 'Elle est gardée sur ce téléphone jusqu’à son envoi. Vous déconnecter maintenant l’efface définitivement.'}
          {refusees > 0 && !apresEnvoiPartiel && ` Dont ${refusees} ${refusees > 1 ? 'refusées' : 'refusée'}, à revoir.`}
        </p>
        <div className="actions">
          {enLigne && (
            <button
              type="button"
              className="bouton-second"
              disabled={occupe !== null}
              onClick={() => void executer('envoi', envoyerPuisDeconnecter)}
            >
              {occupe === 'envoi' ? 'Envoi en cours…' : 'Envoyer, puis me déconnecter'}
            </button>
          )}
          <button
            type="button"
            className="bouton-second bouton-danger"
            disabled={occupe !== null}
            onClick={() => void executer('deconnexion', confirmer)}
          >
            Me déconnecter et effacer
          </button>
          <button type="button" className="bouton" autoFocus disabled={occupe !== null} onClick={annuler}>
            Rester connecté
          </button>
        </div>
      </dialog>
    </div>
  );
}
